import { Injectable } from '@angular/core';
import { PageState, PageStore } from './page.store';

@Injectable({ providedIn: 'root' })
export class PageService {
  constructor(private _pageStore: PageStore) {
  }

  setLoading(loading: boolean) {
    this._pageStore.update((state: PageState) => {
      return {
        ...state,
        loadersCount: loading
          ? state.loadersCount + 1
          : state.loadersCount - 1 > 0 ? state.loadersCount - 1 : 0
      };
    });
  }
}
